import { useState } from 'react'
import { useProducts } from '../context/ProductsContext.jsx'
import './DisclaimerBanner.css'

/** Field names mirror Prod's DisclaimerBanner.jsx BANNER_DEFAULT — see siteContent.banner. */
const BANNER_DEFAULT = {
  text: 'For research use only · Not for human use · Not FDA approved',
  visible: true,
}

export default function DisclaimerBanner() {
  const [dismissed, setDismissed] = useState(false)
  const { siteContent } = useProducts()
  const banner = { ...BANNER_DEFAULT, ...(siteContent?.banner ?? {}) }

  if (dismissed || !banner.visible) return null

  return (
    <div className="disclaimer-banner">
      <p className="disclaimer-banner__text">{banner.text}</p>
      <button
        type="button"
        className="disclaimer-banner__close"
        aria-label="Dismiss disclaimer"
        onClick={() => setDismissed(true)}
      >
        &times;
      </button>
    </div>
  )
}
